import ConfirmDialog from "../../components/ui/ConfirmDialog";
import { ButtonVariant } from "../../components/ui/Button";
import { OnevocaDialogButton } from "./OnevocaDialogButton";

// 레거시 래퍼: 새 코드는 components/ui 의 ConfirmDialog 를 직접 사용한다.
interface OnevocaDialogProps {
  open: boolean;
  title: string | null;
  message: string;
  buttons: OnevocaDialogButton[];
  onVerticalStyle?: boolean;
}

const variantMap: Record<OnevocaDialogButton["style"], ButtonVariant> = {
  normal: "outline",
  solid: "primary",
  delete: "danger",
  cancel: "ghost",
};

function OnevocaDialog(props: OnevocaDialogProps) {
  return (
    <ConfirmDialog
      open={props.open}
      title={props.title}
      message={props.message}
      vertical={props.onVerticalStyle === true}
      actions={props.buttons.map((button) => ({
        label: button.title,
        variant: variantMap[button.style],
        onClick: button.onClick,
      }))}
    />
  );
}

export default OnevocaDialog;
